module.exports = __webpack_public_path__ + "static/img/logo.56adfcd9.svg";